import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiForgotValidatecaptchaMutationRequest,
  PostApiForgotValidatecaptchaMutationResponse,
  PostApiForgotValidatecaptcha401,
  PostApiForgotValidatecaptcha403,
} from "../../../types/PostApiForgotValidatecaptcha";

export function getPostApiForgotValidatecaptchaUrl() {
  return `/api/Forgot/ValidateCaptcha` as const;
}

/**
 * {@link /api/Forgot/ValidateCaptcha}
 */
export async function postApiForgotValidatecaptcha(
  data?: PostApiForgotValidatecaptchaMutationRequest,
  config: Partial<
    RequestConfig<PostApiForgotValidatecaptchaMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiForgotValidatecaptchaMutationResponse,
    ResponseErrorConfig<
      PostApiForgotValidatecaptcha401 | PostApiForgotValidatecaptcha403
    >,
    PostApiForgotValidatecaptchaMutationRequest
  >({
    method: "POST",
    url: getPostApiForgotValidatecaptchaUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
